import React from 'react';

import styled from 'styled-components';
import { ControlLabel } from 'react-bootstrap';

import SimpleSelect from '../../utils/FormWidgets/SimpleSelect';
import {
  ActivitySourceValue,
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  StripeSourceMetadata,
} from '../../../types/Activity';
import { StripeAccount } from '../../../types/Stripe';
import { defaultSourceOptions } from '../ActivityMetaFields/ActivitySourceOptions';

const StyledValidationMessage = styled.div`
  color: red;
  font-size: 16px;
  margin-bottom: 20px;
  margin-top: -10px;
`;

const StyledText = styled.div`
  font-size: 16px;
  margin-bottom: 20px;
`;

type Props = {
  initialCommission: number;
  metadata: StripeSourceMetadata;
  onChange(prop: string, value): void;
  showErrors: boolean;
  stripeAccounts: StripeAccount[];
  source: ActivitySourceValue;
};

// eslint-disable-next-line import/no-unused-modules
export const ConnectStripeAccountForm = ({
  initialCommission,
  onChange,
  metadata,
  showErrors,
  stripeAccounts,
  source,
}: Props) => {
  const stripeId: string = metadata?.stripeId ?? '';
  const commission = initialCommission ?? undefined;
  const label = defaultSourceOptions.find(item => item.value === source)?.label;
  return (
    <>
      <ControlLabel>{'Stripe Account'}</ControlLabel>
      {!!stripeId && <StyledText>{stripeId}</StyledText>}
      <SimpleSelect
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        onChange={value =>
          onChange('metadata', {
            ...metadata,
            stripeId: value,
          })
        }
        value={stripeId}
        name='stripeId'
        data={stripeAccounts.map(v => ({
          label: `ID: ${v.id}, Business Name: ${v.businessName}, Email: ${v.email}`,
          value: v.id,
        }))}
      />

      {showErrors && stripeId.length < 1 && (
        <StyledValidationMessage style={{ marginTop: 10 }}>
          Experiences with a source of {label} must have a Stripe ID
        </StyledValidationMessage>
      )}
      <ControlLabel>{'Commission'}</ControlLabel>
      <StyledText>{commission}</StyledText>
      {!commission && commission !== 0 && (
        <StyledValidationMessage>
          Experiences with a source of {label} must have a commission. Please
          set a commission.
        </StyledValidationMessage>
      )}
    </>
  );
};
